var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 336,
    viewBox: "0 0 512 336",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.172 335.724H8.828A8.829 8.829 0 0 1 0 326.896V9.103A8.829 8.829 0 0 1 8.828.275h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 62.069h512v211.862H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.869 168l22.933-39.721h-45.865L256 88.552l-22.936 39.727h-45.865L210.132 168l-22.933 39.721h45.865L256 247.448l22.936-39.727h45.865L301.869 168zm.433-26.73l-7.933 13.74-7.933-13.74h15.866zM286.869 168l-15.433 26.73h-30.873L225.131 168l15.433-26.73h30.873L286.869 168zM256 114.534l7.936 13.746h-15.872L256 114.534zm-46.302 26.736h15.865l-7.933 13.74-7.932-13.74zm0 53.46l7.933-13.74 7.933 13.74h-15.866zM256 221.466l-7.936-13.746h15.872L256 221.466zm38.369-40.476l7.933 13.74h-15.865l7.932-13.74z",
    fill: "#41479B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIl);
export default __webpack_public_path__ + "static/media/il.b15ab0fbd8eb64fc53be03bcec7df158.svg";
export { ForwardRef as ReactComponent };